import { render, staticRenderFns } from "./GripList.vue?vue&type=template&id=49a1d590&"
import script from "./GripList.vue?vue&type=script&lang=js&"
export * from "./GripList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports